export default angular
  .module("LoadingScriptCtrl", ["ui.bootstrap"])
  .controller("LoadingScriptController", [
    "$scope",
    "$modalInstance",
    "$timeout",
    "ScriptLoading",
    function ($scope, $modalInstance, $timeout, ScriptLoading) {
      $scope.scriptProgress = ScriptLoading.getProgress();
      $scope.isLoaded = ScriptLoading.getIsLoaded();
      $scope.isAllLoaded = ScriptLoading.getLoadingFinished();

      $scope.$watch(
        "isAllLoaded",
        (newVal) => {
          if (newVal.value === true) {
            $scope.ok();
          }
        },
        true,
      );

      $scope.ok = function () {
        $timeout(() => {
          $modalInstance.close();
        }, 1000);
      };
    },
  ]);
